// src/pages/QuanLyNguoiDung/QuanLyNguoiDungDesktop.js
import React, { useState } from "react";

const ROLE_STYLES = {
  'ADMIN': { bg: 'bg-primary-fixed', text: 'text-on-primary-fixed', label: 'Admin' },
  'TRUONG_NGANH': { bg: 'bg-secondary-fixed', text: 'text-on-secondary-fixed-variant', label: 'Trưởng ngành' },
  'GVCN': { bg: 'bg-tertiary-fixed', text: 'text-on-tertiary-fixed-variant', label: 'GVCN' },
  'GV_PHU': { bg: 'bg-surface-variant', text: 'text-on-surface-variant', label: 'Phụ tá' }
};

const DEFAULT_ROLE_STYLE = { bg: 'bg-surface-variant', text: 'text-on-surface-variant', label: '—' };

const QuanLyNguoiDungDesktop = ({ 
  filteredUsers, getTenNganh, getTenLop, 
  onEdit, onResetPassword, onToggleStatus, onDelete,
  isAdmin
}) => {
  const [page, setPage] = useState(1);
  const PER_PAGE = 10;
  const totalPages = Math.ceil(filteredUsers.length / PER_PAGE);
  const startIndex = (page - 1) * PER_PAGE;
  const paginatedUsers = filteredUsers.slice(startIndex, startIndex + PER_PAGE);

  if (filteredUsers.length === 0) {
    return (
      <div className="bg-surface-container-lowest rounded-xl shadow-sm border border-outline-variant">
        <div className="text-center py-16 text-on-surface-variant">
          <span className="material-symbols-outlined text-[64px] mb-4 block">person_off</span>
          <p className="text-body-lg">Không tìm thấy người dùng</p>
          <p className="text-caption mt-1">Thử thay đổi bộ lọc hoặc từ khóa tìm kiếm</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-surface-container-lowest rounded-xl shadow-sm border border-outline-variant overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-left">
          <thead>
            <tr className="bg-surface-container-low border-b border-outline-variant">
              <th className="px-6 py-4 text-label-caps font-label-caps text-on-surface-variant">Người dùng</th>
              <th className="px-6 py-4 text-label-caps font-label-caps text-on-surface-variant">Vai trò</th>
              <th className="px-6 py-4 text-label-caps font-label-caps text-on-surface-variant">Email</th>
              <th className="px-6 py-4 text-label-caps font-label-caps text-on-surface-variant">Ngành / Lớp</th>
              <th className="px-6 py-4 text-label-caps font-label-caps text-on-surface-variant">Trạng thái</th>
              {isAdmin && <th className="px-6 py-4 text-label-caps font-label-caps text-on-surface-variant text-right">Thao tác</th>}
            </tr>
          </thead>
          <tbody className="divide-y divide-outline-variant">
            {paginatedUsers.map((u) => {
              const primaryRole = (u.vaiTro || [])[0];
              const roleStyle = ROLE_STYLES[primaryRole] || DEFAULT_ROLE_STYLE;
              const isActive = u.trangThai !== 'nghi';

              return (
                <tr key={u.uid} className="hover:bg-surface-container-low transition-colors cursor-pointer" onClick={() => isAdmin ? onEdit(u) : null}>
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-3">
                      <div className={`w-10 h-10 rounded-full flex items-center justify-center text-body-md font-bold flex-shrink-0 ${
                        isActive ? 'bg-primary-container text-on-primary-container' : 'bg-surface-container-high text-on-surface-variant'
                      }`}>
                        {(u.tenThanh || u.hoTen || "?")?.charAt(0)}
                      </div>
                      <div className="min-w-0">
                        <p className="text-body-lg font-body-lg text-on-surface truncate">
                          {u.tenThanh && <span className="text-primary font-semibold">{u.tenThanh} </span>}
                          {u.hoTen}
                        </p>
                        <p className="text-caption text-on-surface-variant truncate">
                          {u.soDienThoai || '—'}
                        </p>
                      </div>
                    </div>
                  </td>

                  <td className="px-6 py-4">
                    <div className="flex flex-wrap gap-1">
                      {(u.vaiTro || []).length > 0 ? (u.vaiTro || []).map(role => {
                        const rs = ROLE_STYLES[role] || DEFAULT_ROLE_STYLE;
                        return (
                          <span key={role} className={`${rs.bg} ${rs.text} px-3 py-1 rounded-full text-caption font-bold whitespace-nowrap`}>
                            {rs.label}
                          </span>
                        );
                      }) : <span className="text-caption text-on-surface-variant">—</span>}
                    </div>
                  </td>

                  <td className="px-6 py-4">
                    <p className="text-body-md text-on-surface-variant truncate max-w-[200px]">
                      {u.email || '—'}
                    </p>
                  </td>

                  <td className="px-6 py-4">
                    <div className="flex flex-wrap gap-1">
                      {u.maNganh ? (
                        <span className="bg-green-50 text-green-700 px-3 py-1 rounded-full text-caption font-bold whitespace-nowrap border border-green-200">
                          {getTenNganh(u.maNganh)}
                        </span>
                      ) : <span className="text-caption text-on-surface-variant">—</span>}
                      {u.maLopCN && (
                        <span className="bg-blue-50 text-blue-700 px-3 py-1 rounded-full text-caption font-bold whitespace-nowrap border border-blue-200">
                          {getTenLop(u.maLopCN)}
                        </span>
                      )}
                    </div>
                  </td>

                  <td className="px-6 py-4" onClick={e => isAdmin ? e.stopPropagation() : null}>
                    {isAdmin ? (
                      <button onClick={() => onToggleStatus(u)}
                        className={`flex items-center gap-2 px-3 py-1.5 rounded-full w-fit transition-all hover:scale-105 active:scale-95 ${
                          isActive ? 'text-green-700 bg-green-50 border border-green-200 hover:bg-green-100' 
                            : 'text-on-surface-variant bg-surface-container border border-outline-variant hover:bg-surface-container-high'
                        }`}
                        title={isActive ? 'Bấm để vô hiệu hóa' : 'Bấm để kích hoạt'}>
                        <span className={`w-2.5 h-2.5 rounded-full flex-shrink-0 ${isActive ? 'bg-green-500' : 'bg-outline'}`}></span>
                        <span className="text-caption font-bold">{isActive ? 'Hoạt động' : 'Đã nghỉ'}</span>
                      </button>
                    ) : (
                      <div className={`flex items-center gap-2 px-3 py-1.5 rounded-full w-fit ${
                        isActive ? 'text-green-700 bg-green-50 border border-green-200' : 'text-on-surface-variant bg-surface-container border border-outline-variant'
                      }`}>
                        <span className={`w-2.5 h-2.5 rounded-full flex-shrink-0 ${isActive ? 'bg-green-500' : 'bg-outline'}`}></span>
                        <span className="text-caption font-bold">{isActive ? 'Hoạt động' : 'Đã nghỉ'}</span>
                      </div>
                    )}
                  </td>

                  {isAdmin && (
                    <td className="px-6 py-4 text-right" onClick={e => e.stopPropagation()}>
                      <div className="flex justify-end gap-1">
                        <button onClick={() => onEdit(u)} className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-surface-variant text-on-surface-variant transition-colors" title="Sửa">
                          <span className="material-symbols-outlined text-[20px]">edit</span>
                        </button>
                        <button onClick={() => onResetPassword(u)} className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-surface-variant text-on-surface-variant transition-colors" title="Reset MK">
                          <span className="material-symbols-outlined text-[20px]">lock_reset</span>
                        </button>
                        <button onClick={() => onDelete(u)} className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-error-container text-error transition-colors" title="Xóa">
                          <span className="material-symbols-outlined text-[20px]">delete</span>
                        </button>
                      </div>
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="px-6 py-4 border-t border-outline-variant flex items-center justify-between bg-surface-container-low">
          <p className="text-caption text-on-surface-variant">
            Hiển thị <strong>{startIndex + 1}</strong>–<strong>{Math.min(startIndex + PER_PAGE, filteredUsers.length)}</strong> trong tổng <strong>{filteredUsers.length}</strong> người dùng
          </p>
          <div className="flex items-center gap-1">
            <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1}
              className="w-8 h-8 flex items-center justify-center rounded-lg border border-outline-variant hover:bg-surface-variant transition-colors disabled:opacity-30 disabled:cursor-not-allowed">
              <span className="material-symbols-outlined text-[18px]">chevron_left</span>
            </button>
            {Array.from({ length: totalPages }, (_, i) => i + 1)
              .filter(p => p === 1 || p === totalPages || Math.abs(p - page) <= 1)
              .map((p, idx, arr) => (
                <React.Fragment key={p}>
                  {idx > 0 && arr[idx - 1] !== p - 1 && <span className="text-on-surface-variant px-1">...</span>}
                  <button onClick={() => setPage(p)}
                    className={`w-8 h-8 flex items-center justify-center rounded-lg text-caption font-bold transition-colors ${
                      page === p ? 'bg-primary text-on-primary shadow-sm' : 'hover:bg-surface-variant text-on-surface-variant'
                    }`}>{p}</button>
                </React.Fragment>
              ))}
            <button onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page === totalPages}
              className="w-8 h-8 flex items-center justify-center rounded-lg border border-outline-variant hover:bg-surface-variant transition-colors disabled:opacity-30 disabled:cursor-not-allowed">
              <span className="material-symbols-outlined text-[18px]">chevron_right</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default QuanLyNguoiDungDesktop;